// src/services/milhasService.js
// Acceso a Supabase de la pestaña Millas del panel de admin ("Mi política").
// La tabla tiene RLS por correo (ver 20261030000000_milhas_politica.sql). Si la
// migración todavía no se aplicó, listarPolitica devuelve ok:false y el panel
// sigue funcionando guardando en el dispositivo.
import { supabase } from './supabase';

const CAMPOS = 'id,titulo,texto,orden';

export async function listarPolitica() {
  const { data, error } = await supabase
    .from('milhas_politica')
    .select(CAMPOS)
    .order('orden', { ascending: true })
    .order('created_at', { ascending: true });
  if (error) return { ok: false, items: [] };
  return { ok: true, items: data || [] };
}

// Crea (sin id) o actualiza (con id) una entrada y devuelve la fila guardada.
export async function guardarEntradaPolitica({ id, titulo, texto, orden = 0 }) {
  const q = id
    ? supabase.from('milhas_politica').update({ titulo, texto, updated_at: new Date().toISOString() }).eq('id', id)
    : supabase.from('milhas_politica').insert({ titulo, texto, orden });
  const { data, error } = await q.select(CAMPOS).single();
  if (error) throw error;
  return data;
}

export async function borrarEntradaPolitica(id) {
  const { error } = await supabase.from('milhas_politica').delete().eq('id', id);
  if (error) throw error;
}

// Sube de una vez las entradas que estaban solo en el dispositivo.
export async function migrarPolitica(entradas) {
  const filas = entradas.map((e, i) => ({ titulo: e.titulo, texto: e.texto, orden: i }));
  const { data, error } = await supabase.from('milhas_politica').insert(filas).select(CAMPOS).order('orden', { ascending: true });
  if (error) throw error;
  return data || [];
}
